import { config } from "config";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TrafficViolationState } from ".";

const default_page_size = config.PAGE_SIZE;

const initialState: TrafficViolationState = {
  loading: true,
  trafficViolations: [],
  trafficViolation: null,
  refresh: 0,
  current_filters: {},
  refreshLoader: false,
  filters: { page: 1, page_size: default_page_size },
  count: 0,
};

export const trafficViolationSlice = createSlice({
  name: "trafficViolation",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    resetFilters: (state) => {
      state.refresh += 1;
      state.refreshLoader = true;
      state.filters = initialState.filters;
      state.current_filters = initialState.current_filters;
    },
    setTrafficViolations: (state, action) => {
      const { trafficViolations, count } = action.payload;
      state.trafficViolations = trafficViolations;
      state.count = count;
      state.refreshLoader = false;
    },
    setTrafficViolation: (state, action) => {
      state.trafficViolation = action.payload;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.refresh += 1;
      state.refreshLoader = true;
      state.filters.page = action.payload;
    },
    refresh: (state) => {
      state.refresh += 1;
      state.refreshLoader = true;
    },
    resetPage: (state) => {
      state.filters.page = 1;
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
      state.refreshLoader = true;
    },
    setCurrentFilters: (state, action) => {
      state.current_filters = action.payload;
    },
  },
});

const trafficViolationReducer = trafficViolationSlice.reducer;

export const trafficViolationActions = trafficViolationSlice.actions;
export default trafficViolationReducer; 